import "./FormComponents.css";
export default function FormHeading(props) {
  return (
    <div className="form-heading">
      <h1> {props.h1} </h1>
      <p> {props.p} </p>
    </div>
  );
}
